import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom';
import { SimpleTab } from '../../../../../Component/Common/Components/Tabs/SimpleTab';
import { ComingSoonPage } from '../../../../ComingSoon/dashboardPage';
import { useRouteMatch } from '../../../../../Helpers/RouteMatcher';
import { useRecoilValue } from 'recoil';
import { BBBEEScorecardAtom } from '../../../../../State/BBBEEScorecard.Atom';
import { MDBox } from '../../../../../Component/Common/Components/MDBox';
import { MDTypography } from '../../../../../Component/Common/Components/MDTypography';
import { FileManagementUpload } from './FileManagementUpload';
import { isNullOrEmpty } from '../../../../../Component/Model/helpers';
import { FileManagementImport } from './FileManagementImport';

export const FileManagementBase = () => {
    const scorecard = useRecoilValue(BBBEEScorecardAtom);

    const routes = [
        `/bee/scorecard/${scorecard.scorecardId}/fileManagement/uploaded`,
        `/bee/scorecard/${scorecard.scorecardId}/fileManagement/imported`
    ];

    const labels = ['Uploaded', 'Imported'];

    const tabsData = routes.map((route, index) => ({
        route,
        label: labels[index]
    }));

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;
    const currentTabIndex = routes.findIndex(route => route === currentTab);

    const handleRedirect = () => {
        if (currentTabIndex === -1) {
            return <Redirect to={routes[0]} />;
        }
        return null;
    };

    if (isNullOrEmpty(scorecard.scorecardId)) {
        return null;
    }
    return (
        <>
            <MDBox style={{ paddingBottom: "10px" }}>
                <MDTypography variant='h4' fontWeight='bold' >
                    File Management
                </MDTypography>
            </MDBox>
            <SimpleTab currentTab={currentTab} tabsData={tabsData} />
            <Switch>
                {handleRedirect()}
                <Route path={routes[0]}>
                    <FileManagementUpload scorecardId={scorecard.scorecardId} />
                </Route>
                <Route path={routes[1]}>
                    <FileManagementImport scorecardId={scorecard.scorecardId} />
                </Route>
            </Switch>
        </>
    )
}
